<script>
  import { onMount } from "svelte";
  
  export let expanded = -1;
  export let items = [];
  export let indent = 0;
  export let level = 1;
  export let url_prefix = '';
  export let storage_key = 'topics_menu';
  export let active_id = null;
  
  onMount(() => {
    /*let record = localStorage.getItem(storage_key);
    if (record)
      expanded = JSON.parse(record)[level];*/
    expanded = -1;
  });
  
  
  function expand(t) {
    let record = null; // localStorage.getItem(storage_key);
    if (expanded == t.i)
      expanded = -1;
    else
      expanded = t.i;
    if (!record)
      record = {};
    else
      record = JSON.parse(record);
    record[level] = expanded;
    //localStorage.setItem(storage_key, JSON.stringify(record));
  }
</script>
{#if items.length}
<ul class:nav-nested='{indent > 0}' class='nav d-flex flex-column mt-1'>
{#each items as {id, title, image, about, children}, i}
<li class:active='{expanded == i}' class='nav-item px-1'>
<div class='d-flex justify-content-start'>
<small class='pr-1 text-muted' on:click='{() => expand({i})}' on:keypress='{() => expand({i})}'>
<i class:fa-minus='{expanded == i}' class:fa-plus='{expanded != i}' class:unvisible='{!children.length}' class='fa'></i>
</small>
<a class:selected='{expanded == i || id == active_id}' class='text-inherit' href='{url_prefix}/{id}' on:click='{() => expand({i})}' on:keypress='{() => expand({i})}' role='button' title='{about}'>
{title}
</a>
</div>
{#if expanded == i}
<svelte:self active_id="{id}" items="{children}" indent="{indent + 24 * level}" level="{level + 1}" url_prefix="{url_prefix}"/>
{/if}
</li>
{/each}
</ul>
{/if}
